import { render } from "./CrmDealTasksView.vue?vue&type=template&id=851d2086&scoped=true"
import script from "./CrmDealTasksView.vue?vue&type=script&lang=js"
export * from "./CrmDealTasksView.vue?vue&type=script&lang=js"

import "./CrmDealTasksView.vue?vue&type=style&index=0&id=851d2086&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-851d2086"]])

export default __exports__